import { token } from 'odyssey';
import { media } from 'styled-bootstrap-grid';
import styled, { css } from 'styled-components';

export const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const StyledButton = styled.button<{
  isSmall: boolean;
  isLarge: boolean;
  isInline: boolean;
  isInverted: boolean;
  isPrimary: boolean;
  isNarrow?: boolean;
  icon?: object;
}>`
  display: flex;
  align-items: center;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  border-color: ${token('button-border-secondary-color')};
  justify-content: center;
  font-size: ${token('font-size-sm')};
  font-weight: ${token('button-typography-default-font-weight')};
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.25s ease;
  width: 100%;
  min-width: ${({ isNarrow }) => (isNarrow ? '100px' : '160px')};
  ${({ isInline }) => {
    return `height: ${isInline ? '46px' : 'auto'};`;
  }}
  ${media.md`
    width: initial;
  `}

  background: ${token('button-secondary-bg')};
  color: ${token('button-secondary-fg')};

  &:focus {
    outline: 2px solid ${token('color-grey-2-neutral')};
    outline-offset: 2px;
  }

  &[disabled] {
    color: ${token('button-secondary-disabled-fg')};
    border-color: ${token('button-border-disabled-color')};
    cursor: auto;
    background: ${token('button-secondary-disabled-bg')};
  }

  ${({ isSmall, isLarge, icon }) => {
    if (isLarge) {
      return `padding: 16px 10px 16px ${icon ? '92px' : '10px'};
              min-width: 266px;`;
    } else if (isSmall) {
      return `padding: 8px 16px 8px ${icon ? '12px' : '16px'};`;
    } else {
      return `padding: 16px 32px 16px ${icon ? '26px' : '32px'};`;
    }
  }};

  ${({ isInverted }) =>
    isInverted &&
    css`
      background: color-mix(in srgb, ${token('button-secondary-bg')} 0%, transparent);
      border-color: ${token('button-secondary-bg')};
      color: ${token('button-secondary-bg')};

      &:hover {
        background: color-mix(in srgb, ${token('button-secondary-bg')} 10%, transparent);
      }

      &[disabled] {
        color: ${token('button-secondary-disabled-fg')};
        border-color: ${token('button-border-disabled-color')};
        background: ${token('button-secondary-disabled-bg')};
      }
    `}

  ${({ isPrimary }) =>
    isPrimary &&
    css`
      background: ${token('button-primary-bg')};
      border-color: ${token('button-border-default-color')};
      color: ${token('button-primary-fg')};

      &:hover {
        background-color: color-mix(in srgb, ${token('button-primary-bg')} 80%, white);
        border-color: color-mix(in srgb, ${token('button-primary-bg')} 80%, white);
      }

      &[disabled] {
        color: ${token('button-primary-disabled-fg')};
        border-color: ${token('button-border-disabled-color')};
        background: ${token('button-primary-disabled-bg')};
      }
    `};
`;
